// extracted by mini-css-extract-plugin
export default {"superLink":"superLink-lGgz"};